
/**
 * This file was auto-generated inhouse by the 'openapi-typescript-configuration.mts' script.
 * Do not make direct changes to the file.
 */
import { toJsonLuxon } from "tp/views/common/luxonParsing";
import { HttpClient, HttpRequest } from "tp/views/common/HttpClient";
import { TimeplanURLs } from "./common/reducers/runtime";
import { paths, components } from "./timeplan-api-schema";
import { DateTime } from "luxon";

let client: HttpClient = null;

export const initialize = (urls: TimeplanURLs): void => {
    client ??= new HttpClient(urls.apiUrl, toJsonLuxon);
};

export const absencePost = async (
    requestBody: components["schemas"]["ReportAbsence.Command"]
): Promise<void> => {
    return await client.fetch(HttpRequest.postJson("/v1/absence", requestBody));
};
export type absencePostError = { jsonError?: paths["/v1/absence"]["post"]["responses"]["400"]["content"]["application/json"], message?: string, response: Response };
export const absenceDelete = async (): Promise<components["schemas"]["UndoReportedAbsence.Result"]> => {
    return await client.fetch(HttpRequest.delete("/v1/absence"));
};
export const accountbalanceexportCsvGet = async (
    hotelRef?: number,
    fromDate?: DateTime
): Promise<void> => {
    const search = new URLSearchParams();
    if (hotelRef !== undefined) search.set("hotelRef", String(hotelRef));
    if (fromDate !== undefined) search.set("fromDate", String(fromDate));
    return await client.fetch(HttpRequest.get(`/v1/accountbalanceexport/csv/?${search}`));
};
export const accountbalanceexportCsvPost = async (
    hotelRef?: number,
    fromDate?: DateTime
): Promise<void> => {
    const search = new URLSearchParams();
    if (hotelRef !== undefined) search.set("hotelRef", String(hotelRef));
    if (fromDate !== undefined) search.set("fromDate", String(fromDate));
    return await client.fetch(HttpRequest.post(`/v1/accountbalanceexport/csv/?${search}`));
};
export const accountbalanceexportCsv_v2Get = async (
    fromDate?: DateTime
): Promise<void> => {
    const search = new URLSearchParams();
    if (fromDate !== undefined) search.set("fromDate", String(fromDate));
    return await client.fetch(HttpRequest.get(`/v1/accountbalanceexport/csv_v2/?${search}`));
};
export const accountbalanceexportCsv_v2Post = async (
    fromDate?: DateTime
): Promise<void> => {
    const search = new URLSearchParams();
    if (fromDate !== undefined) search.set("fromDate", String(fromDate));
    return await client.fetch(HttpRequest.post(`/v1/accountbalanceexport/csv_v2/?${search}`));
};
export const accountbalanceexportPersonaccountsaldoGet = async (
    hotelRef?: number,
    fromDate?: DateTime,
    untilDate?: DateTime,
    accountGroupName?: string
): Promise<void> => {
    const search = new URLSearchParams();
    if (hotelRef !== undefined) search.set("hotelRef", String(hotelRef));
    if (fromDate !== undefined) search.set("fromDate", String(fromDate));
    if (untilDate !== undefined) search.set("untilDate", String(untilDate));
    if (accountGroupName !== undefined) search.set("accountGroupName", accountGroupName);
    return await client.fetch(HttpRequest.get(`/v1/accountbalanceexport/personaccountsaldo/?${search}`));
};
export const accountbalanceexportPersoncsvGet = async (
    hotelRef?: number,
    fromDate?: DateTime,
    untilDate?: DateTime
): Promise<void> => {
    const search = new URLSearchParams();
    if (hotelRef !== undefined) search.set("hotelRef", String(hotelRef));
    if (fromDate !== undefined) search.set("fromDate", String(fromDate));
    if (untilDate !== undefined) search.set("untilDate", String(untilDate));
    return await client.fetch(HttpRequest.get(`/v1/accountbalanceexport/personcsv/?${search}`));
};
export const approveTimeReportsSalaryPeriodRefGet = async (
    salaryPeriodRef: number,
    includeApproved?: boolean,
    includeAllHotels?: boolean
): Promise<components["schemas"]["SalaryPeriodDetails"]> => {
    const search = new URLSearchParams();
    if (includeApproved !== undefined) search.set("includeApproved", String(includeApproved));
    if (includeAllHotels !== undefined) search.set("includeAllHotels", String(includeAllHotels));
    return await client.fetch(HttpRequest.get(`/v1/ApproveTimeReports/${encodeURIComponent(String(salaryPeriodRef))}/?${search}`));
};
export const cacheKeyDelete = async (
    key: string
): Promise<void> => {
    return await client.fetch(HttpRequest.delete(`/v1/Cache/${encodeURIComponent(key)}`));
};
export const collectiveagreementCollectiveAgreementRefContractsettingsGet = async (
    collectiveAgreementRef: number
): Promise<components["schemas"]["GetContractSettings.Response"]> => {
    return await client.fetch(HttpRequest.get(`/v1/collectiveagreement/${encodeURIComponent(String(collectiveAgreementRef))}/contractsettings`));
};
export const collectiveagreementCollectiveAgreementRefContractsettingsPut = async (
    collectiveAgreementRef: number,
    requestBody: components["schemas"]["ContractSettings"]
): Promise<void> => {
    return await client.fetch(HttpRequest.putJson(`/v1/collectiveagreement/${encodeURIComponent(String(collectiveAgreementRef))}/contractsettings`, requestBody));
};
export const collectiveagreementCollectiveAgreementRefSalaryrulesGet = async (
    collectiveAgreementRef: number
): Promise<components["schemas"]["SalaryField"][]> => {
    return await client.fetch(HttpRequest.get(`/v1/collectiveagreement/${encodeURIComponent(String(collectiveAgreementRef))}/salaryrules`));
};
export const collectiveagreementCollectiveAgreementRefSalaryrulesPut = async (
    collectiveAgreementRef: number,
    requestBody: components["schemas"]["SalaryField"][]
): Promise<void> => {
    return await client.fetch(HttpRequest.putJson(`/v1/collectiveagreement/${encodeURIComponent(String(collectiveAgreementRef))}/salaryrules`, requestBody));
};
export const collectiveagreementAvailablecollectiveagreementsGet = async (): Promise<components["schemas"]["NameAndRefResult"][]> => {
    return await client.fetch(HttpRequest.get("/v1/collectiveagreement/availablecollectiveagreements"));
};
export const companyLogoGet = async (): Promise<void> => {
    return await client.fetch(HttpRequest.get("/v1/company/logo"));
};
export const dashboardCurrenteventsGet = async (
    days?: number,
    category?: ("PublicHoliday" | "OneYearIndustryExperience" | "TwoYearsIndustryExperience" | "ThreeYearsIndustryExperience" | "BirthDay" | "ThreeMonthContract" | "SixMonthContract" | "WorkpermissionWarnings")[]
): Promise<components["schemas"]["CurrentEvent.Result"][]> => {
    const search = new URLSearchParams();
    if (days !== undefined) search.set("days", String(days));
    for (const element of category ?? []) {
        search.append("category", String(element));
    }
    return await client.fetch(HttpRequest.get(`/v1/dashboard/currentevents/?${search}`));
};
export const dashboardTimedataGet = async (
    fromDate?: DateTime,
    untilDate?: DateTime
): Promise<components["schemas"]["GetTimeDataResponse"]> => {
    const search = new URLSearchParams();
    if (fromDate !== undefined) search.set("fromDate", String(fromDate));
    if (untilDate !== undefined) search.set("untilDate", String(untilDate));
    return await client.fetch(HttpRequest.get(`/v1/dashboard/timedata/?${search}`));
};
export const dashboardEmploymentsGet = async (
    fromDate?: DateTime,
    untilDate?: DateTime
): Promise<components["schemas"]["Employments"][]> => {
    const search = new URLSearchParams();
    if (fromDate !== undefined) search.set("fromDate", String(fromDate));
    if (untilDate !== undefined) search.set("untilDate", String(untilDate));
    return await client.fetch(HttpRequest.get(`/v1/dashboard/employments/?${search}`));
};
export const dashboardAgreementsGet = async (): Promise<components["schemas"]["Agreements"][]> => {
    return await client.fetch(HttpRequest.get("/v1/dashboard/agreements"));
};
export const dashboardDeviationsGet = async (
    fromDate?: DateTime,
    untilDate?: DateTime,
    deviationsChecked?: number[]
): Promise<components["schemas"]["GetDeviationResponse"]> => {
    const search = new URLSearchParams();
    if (fromDate !== undefined) search.set("fromDate", String(fromDate));
    if (untilDate !== undefined) search.set("untilDate", String(untilDate));
    for (const element of deviationsChecked ?? []) {
        search.append("deviationsChecked", String(element));
    }
    return await client.fetch(HttpRequest.get(`/v1/dashboard/deviations/?${search}`));
};
export const dashboardOverviewGet = async (): Promise<components["schemas"]["Overview.Result"]> => {
    return await client.fetch(HttpRequest.get("/v1/dashboard/overview"));
};
export const dashboardSupportwidgetGet = async (): Promise<components["schemas"]["SupportWidget.Result"]> => {
    return await client.fetch(HttpRequest.get("/v1/dashboard/supportwidget"));
};
export type dashboardSupportwidgetGetError = { jsonError?: paths["/v1/dashboard/supportwidget"]["get"]["responses"]["400"]["content"]["application/json"], message?: string, response: Response };
export const dashboardGet = async (): Promise<components["schemas"]["StartPage"]> => {
    return await client.fetch(HttpRequest.get("/v1/dashboard"));
};
export const dashboardPut = async (
    requestBody: components["schemas"]["Dashboard"]
): Promise<components["schemas"]["Dashboard"]> => {
    return await client.fetch(HttpRequest.putJson("/v1/dashboard", requestBody));
};
export const dataimportForenadebudgetPost = async (
    requestBody: components["schemas"]["ForenadeBudgetUploadParserQuery"]
): Promise<void> => {
    return await client.fetch(HttpRequest.postJson("/v1/dataimport/forenadebudget", requestBody));
};
export const dataimportBudgetPost = async (
    requestBody: components["schemas"]["BudgetImportParserQuery"]
): Promise<void> => {
    return await client.fetch(HttpRequest.postJson("/v1/dataimport/budget", requestBody));
};
export const dataimportCreateorupdatecostdivisionPost = async (
    requestBody: components["schemas"]["CreateOrUpdateCostDivisionRequest"]
): Promise<void> => {
    return await client.fetch(HttpRequest.postJson("/v1/dataimport/createorupdatecostdivision", requestBody));
};
export const dataimportHogiapersonimportPost = async (): Promise<void> => {
    return await client.fetch(HttpRequest.post("/v1/dataimport/hogiapersonimport"));
};
export const dataimportCreateorupdateperson_csvPost = async (): Promise<void> => {
    return await client.fetch(HttpRequest.post("/v1/dataimport/createorupdateperson_csv"));
};
export const dayoverviewDateGet = async (
    date: DateTime,
    costDivisionRefs?: number[]
): Promise<components["schemas"]["DayOverview.Response"]> => {
    const search = new URLSearchParams();
    for (const element of costDivisionRefs ?? []) {
        search.append("costDivisionRefs", String(element));
    }
    return await client.fetch(HttpRequest.get(`/v1/dayoverview/${date.toISODate()}/?${search}`));
};
export const dayoverviewDatePut = async (
    date: DateTime,
    requestBody: components["schemas"]["EditableDayTask"][]
): Promise<void> => {
    return await client.fetch(HttpRequest.putJson(`/v1/dayoverview/${date.toISODate()}`, requestBody));
};
export const dayoverviewGet = async (): Promise<components["schemas"]["LastDateResult"]> => {
    return await client.fetch(HttpRequest.get("/v1/dayoverview"));
};
export const digitalSigningContractRefLogsGet = async (
    contractRef: number
): Promise<components["schemas"]["SigningLogsAndStatus"]> => {
    return await client.fetch(HttpRequest.get(`/v1/DigitalSigning/${encodeURIComponent(String(contractRef))}/logs`));
};
export const digitalSigningContractRefCancelPost = async (
    contractRef: number
): Promise<void> => {
    return await client.fetch(HttpRequest.post(`/v1/DigitalSigning/${encodeURIComponent(String(contractRef))}/cancel`));
};
export const digitalSigningContractRefSendPost = async (
    contractRef: number,
    requestBody: components["schemas"]["SendForSigningCommand"]
): Promise<void> => {
    return await client.fetch(HttpRequest.postJson(`/v1/DigitalSigning/${encodeURIComponent(String(contractRef))}/send`, requestBody));
};
export const digitalSigningAssentlycallbackPost = async (
    requestBody: components["schemas"]["CaseEventModel"]
): Promise<void> => {
    return await client.fetch(HttpRequest.postJson("/v1/DigitalSigning/assentlycallback", requestBody));
};
export const usersettingsEmailnotificationsGet = async (): Promise<components["schemas"]["EmailNotificationsModel"]> => {
    return await client.fetch(HttpRequest.get("/v1/usersettings/emailnotifications"));
};
export const usersettingsEmailnotificationsPost = async (
    requestBody: components["schemas"]["EmailNotificationsModel"]
): Promise<void> => {
    return await client.fetch(HttpRequest.postJson("/v1/usersettings/emailnotifications", requestBody));
};
export const settingsExceptiondatesGet = async (): Promise<components["schemas"]["ExceptionDateDataQuery.Response"]> => {
    return await client.fetch(HttpRequest.get("/v1/settings/exceptiondates"));
};
export const settingsExceptiondatesPost = async (
    requestBody: components["schemas"]["UpdateExceptionDatesAndGroupsCommand"]
): Promise<components["schemas"]["ExceptionDateDataQuery.Response"]> => {
    return await client.fetch(HttpRequest.postJson("/v1/settings/exceptiondates", requestBody));
};
export const helpcenterGet = async (): Promise<{
              [key: string]: components["schemas"]["VideoGuide"][];
            }> => {
    return await client.fetch(HttpRequest.get("/v1/helpcenter"));
};
export const helpcenterVideoGuideIdWatchedPost = async (
    videoGuideId: string
): Promise<void> => {
    return await client.fetch(HttpRequest.post(`/v1/helpcenter/${encodeURIComponent(videoGuideId)}/watched`));
};
export const helpcenterVideoGuideIdShownPost = async (
    videoGuideId: string
): Promise<void> => {
    return await client.fetch(HttpRequest.post(`/v1/helpcenter/${encodeURIComponent(videoGuideId)}/shown`));
};
export const settingsLicenseGet = async (): Promise<components["schemas"]["LicenseSettingResult"]> => {
    return await client.fetch(HttpRequest.get("/v1/settings/license"));
};
export const settingsLicensePost = async (
    requestBody: components["schemas"]["LicenseSettingBody"]
): Promise<void> => {
    return await client.fetch(HttpRequest.postJson("/v1/settings/license", requestBody));
};
export const master_dataCost_divisionsGet = async (): Promise<components["schemas"]["MasterData.Models.CostDivision"][]> => {
    return await client.fetch(HttpRequest.get("/v1/master_data/cost_divisions"));
};
export const monthoverviewGetcosttimeGet = async (
    fromDate?: DateTime,
    untilDate?: DateTime,
    costDivision?: number[]
): Promise<void> => {
    const search = new URLSearchParams();
    if (fromDate !== undefined) search.set("fromDate", String(fromDate));
    if (untilDate !== undefined) search.set("untilDate", String(untilDate));
    for (const element of costDivision ?? []) {
        search.append("costDivision", String(element));
    }
    return await client.fetch(HttpRequest.get(`/v1/monthoverview/getcosttime/?${search}`));
};
export const monthoverviewGetscheduledtimeGet = async (
    fromDate?: DateTime,
    untilDate?: DateTime,
    costDivision?: number[]
): Promise<void> => {
    const search = new URLSearchParams();
    if (fromDate !== undefined) search.set("fromDate", String(fromDate));
    if (untilDate !== undefined) search.set("untilDate", String(untilDate));
    for (const element of costDivision ?? []) {
        search.append("costDivision", String(element));
    }
    return await client.fetch(HttpRequest.get(`/v1/monthoverview/getscheduledtime/?${search}`));
};
export const monthoverviewGetdaytaskmessagestatusdataGet = async (
    fromDate?: DateTime,
    untilDate?: DateTime,
    personRef?: number[]
): Promise<void> => {
    const search = new URLSearchParams();
    if (fromDate !== undefined) search.set("fromDate", String(fromDate));
    if (untilDate !== undefined) search.set("untilDate", String(untilDate));
    for (const element of personRef ?? []) {
        search.append("personRef", String(element));
    }
    return await client.fetch(HttpRequest.get(`/v1/monthoverview/getdaytaskmessagestatusdata/?${search}`));
};
export const monthoverviewDaytaskPost = async (
    requestBody: components["schemas"]["CreateDayTask.Command"]
): Promise<number> => {
    return await client.fetch(HttpRequest.postJson("/v1/monthoverview/daytask", requestBody));
};
export const monthoverviewDaytaskfromtemplatePost = async (
    requestBody: components["schemas"]["FromTemplateCommand"]
): Promise<number> => {
    return await client.fetch(HttpRequest.postJson("/v1/monthoverview/daytaskfromtemplate", requestBody));
};
export const monthoverviewGetownrequestdataGet = async (
    fromDate?: DateTime,
    untilDate?: DateTime,
    costDivisions?: number[],
    selectedDetailLevel?: "Compact" | "Detailed",
    filterOptions?: "ShowAllPersons" | "OnlyPersonsWithTasks"
): Promise<void> => {
    const search = new URLSearchParams();
    if (fromDate !== undefined) search.set("fromDate", String(fromDate));
    if (untilDate !== undefined) search.set("untilDate", String(untilDate));
    for (const element of costDivisions ?? []) {
        search.append("costDivisions", String(element));
    }
    if (selectedDetailLevel !== undefined) search.set("selectedDetailLevel", String(selectedDetailLevel));
    if (filterOptions !== undefined) search.set("filterOptions", String(filterOptions));
    return await client.fetch(HttpRequest.get(`/v1/monthoverview/getownrequestdata/?${search}`));
};
export const monthoverviewGettaskchangesGet = async (): Promise<components["schemas"]["TaskChanges"][]> => {
    return await client.fetch(HttpRequest.get("/v1/monthoverview/gettaskchanges"));
};
export const monthoverviewInfoColumnPost = async (
    requestBody: components["schemas"]["MonthOverviewInfoColumnSettingsModel"]
): Promise<void> => {
    return await client.fetch(HttpRequest.postJson("/v1/monthoverview/infoColumn", requestBody));
};
export const onboardingCompletePost = async (
    requestBody: components["schemas"]["CollectedOnboardingData"]
): Promise<void> => {
    return await client.fetch(HttpRequest.postJson("/v1/Onboarding/complete", requestBody));
};
export const onboardingCollectiveagreementsGet = async (
    priceId?: string
): Promise<components["schemas"]["NameAndRefResult"][]> => {
    const search = new URLSearchParams();
    if (priceId !== undefined) search.set("priceId", priceId);
    return await client.fetch(HttpRequest.get(`/v1/Onboarding/collectiveagreements/?${search}`));
};
export const onboardingIntroductionGet = async (): Promise<components["schemas"]["IntroductionData"]> => {
    return await client.fetch(HttpRequest.get("/v1/Onboarding/introduction"));
};
export const organizationGet = async (): Promise<components["schemas"]["Models.Organization"]> => {
    return await client.fetch(HttpRequest.get("/v1/organization"));
};
export const organizationHotelPatch = async (
    requestBody: components["schemas"]["UpdateHotel.Command"]
): Promise<void> => {
    return await client.fetch(HttpRequest.patch("/v1/organization/hotel", requestBody));
};
export const organizationCostDivisionsPost = async (
    requestBody: components["schemas"]["CreateCostDivision.Command"]
): Promise<void> => {
    return await client.fetch(HttpRequest.postJson("/v1/organization/costDivisions", requestBody));
};
export const organizationCostDivisionsCostDivisionRefDelete = async (
    costDivisionRef: number
): Promise<void> => {
    return await client.fetch(HttpRequest.delete(`/v1/organization/costDivisions/${encodeURIComponent(String(costDivisionRef))}`));
};
export const organizationCostDivisionsCostDivisionRefPatch = async (
    costDivisionRef: number,
    requestBody: components["schemas"]["Models.UpdateCostDivision"]
): Promise<void> => {
    return await client.fetch(HttpRequest.patch(`/v1/organization/costDivisions/${encodeURIComponent(String(costDivisionRef))}`, requestBody));
};
export const videoguidesGet = async (): Promise<void> => {
    return await client.fetch(HttpRequest.get("/qa/videoguides"));
};
export const siteReferencegroupsGet = async (): Promise<components["schemas"]["ReferenceGroupResult"][]> => {
    return await client.fetch(HttpRequest.get("/v1/site/referencegroups"));
};
export const siteReferencegroupsPost = async (
    requestBody: components["schemas"]["ReferenceGroupCommand"]
): Promise<components["schemas"]["ReferenceGroupResult"]> => {
    return await client.fetch(HttpRequest.postJson("/v1/site/referencegroups", requestBody));
};
export const siteReferencegroupsReferenceGroupRefPut = async (
    referenceGroupRef: number,
    requestBody: components["schemas"]["ReferenceGroupCommand"]
): Promise<components["schemas"]["ReferenceGroupResult"]> => {
    return await client.fetch(HttpRequest.putJson(`/v1/site/referencegroups/${encodeURIComponent(String(referenceGroupRef))}`, requestBody));
};
export const siteReferencegroupsReferenceGroupRefDelete = async (
    referenceGroupRef: number
): Promise<void> => {
    return await client.fetch(HttpRequest.delete(`/v1/site/referencegroups/${encodeURIComponent(String(referenceGroupRef))}`));
};
export const staffMainPersonRefRelativesGet = async (
    personRef: number
): Promise<components["schemas"]["RelativeData"][]> => {
    return await client.fetch(HttpRequest.get(`/v1/StaffMain/${encodeURIComponent(String(personRef))}/relatives`));
};
export const staffMainPersonRefRelativesPut = async (
    personRef: number,
    requestBody: components["schemas"]["RelativesWrite"][]
): Promise<components["schemas"]["RelativeData"][]> => {
    return await client.fetch(HttpRequest.putJson(`/v1/StaffMain/${encodeURIComponent(String(personRef))}/relatives`, requestBody));
};
export const salary_serviceExport_zipGet = async (
    salaryPeriodRef?: number,
    hotelRefs?: number[],
    customIdentifier?: string,
    kind?: "Complete" | "Preliminary"
): Promise<void> => {
    const search = new URLSearchParams();
    if (salaryPeriodRef !== undefined) search.set("salaryPeriodRef", String(salaryPeriodRef));
    for (const element of hotelRefs ?? []) {
        search.append("hotelRefs", String(element));
    }
    if (customIdentifier !== undefined) search.set("customIdentifier", customIdentifier);
    if (kind !== undefined) search.set("kind", String(kind));
    return await client.fetch(HttpRequest.get(`/v1/salary_service/export_zip/?${search}`));
};
export const salary_serviceExport_singleGet = async (
    fromDate?: DateTime,
    untilDate?: DateTime,
    hotelRef?: number,
    customIdentifier?: string,
    fileIndex?: number
): Promise<void> => {
    const search = new URLSearchParams();
    if (fromDate !== undefined) search.set("fromDate", String(fromDate));
    if (untilDate !== undefined) search.set("untilDate", String(untilDate));
    if (hotelRef !== undefined) search.set("hotelRef", String(hotelRef));
    if (customIdentifier !== undefined) search.set("customIdentifier", customIdentifier);
    if (fileIndex !== undefined) search.set("fileIndex", String(fileIndex));
    return await client.fetch(HttpRequest.get(`/v1/salary_service/export_single/?${search}`));
};
export const salary_serviceGet = async (): Promise<string> => {
    return await client.fetch(HttpRequest.get("/v1/salary_service"));
};
export const integrationsSdworxExportEmployment_updateGet = async (): Promise<void> => {
    return await client.fetch(HttpRequest.get("/v1/integrations/sdworx/export/employment_update"));
};
export const integrationsSdworxImportEmployment_updatePost = async (): Promise<void> => {
    return await client.fetch(HttpRequest.post("/v1/integrations/sdworx/import/employment_update"));
};
export const integrationsSdworxImportStaff_vacationPost = async (): Promise<void> => {
    return await client.fetch(HttpRequest.post("/v1/integrations/sdworx/import/staff_vacation"));
};
export const securityLoginPost = async (
    requestBody: components["schemas"]["LoginRequest"]
): Promise<void> => {
    return await client.fetch(HttpRequest.postJson("/v1/Security/login", requestBody));
};
export const securityTerminalloginPost = async (
    requestBody: components["schemas"]["TerminalLogin.Query"]
): Promise<void> => {
    return await client.fetch(HttpRequest.postJson("/v1/Security/terminallogin", requestBody));
};
export const securityWhoamiGet = async (): Promise<void> => {
    return await client.fetch(HttpRequest.get("/v1/Security/whoami"));
};
export const securityChangepasswordPost = async (
    requestBody: components["schemas"]["ChangePassword.Command"]
): Promise<void> => {
    return await client.fetch(HttpRequest.postJson("/v1/Security/changepassword", requestBody));
};
export const securityResetpasswordPost = async (
    requestBody: components["schemas"]["ResetPassword.Command"]
): Promise<void> => {
    return await client.fetch(HttpRequest.postJson("/v1/Security/resetpassword", requestBody));
};
export const securitySetemailusernamePost = async (
    requestBody: components["schemas"]["SetEmailAsUserName.Command"]
): Promise<void> => {
    return await client.fetch(HttpRequest.postJson("/v1/Security/setemailusername", requestBody));
};
export const securityApiKeysPost = async (
    requestBody: components["schemas"]["CreateApiKeyRequest"]
): Promise<components["schemas"]["ApiKey"]> => {
    return await client.fetch(HttpRequest.postJson("/v1/Security/apiKeys", requestBody));
};
export const securityApiKeysApiKeyRefRevokePost = async (
    apiKeyRef: number
): Promise<void> => {
    return await client.fetch(HttpRequest.post(`/v1/Security/apiKeys/${encodeURIComponent(String(apiKeyRef))}/revoke`));
};
export const shiftDialogGet = async (
    cds?: number[]
): Promise<components["schemas"]["ShiftDialog.Result"]> => {
    const search = new URLSearchParams();
    for (const element of cds ?? []) {
        search.append("cds", String(element));
    }
    return await client.fetch(HttpRequest.get(`/v1/shiftDialog/?${search}`));
};
export const shiftDialogDatePersonsPersonRefGet = async (
    date: DateTime,
    personRef: number,
    cds?: number[]
): Promise<components["schemas"]["ShiftDialog.Result"]> => {
    const search = new URLSearchParams();
    for (const element of cds ?? []) {
        search.append("cds", String(element));
    }
    return await client.fetch(HttpRequest.get(`/v1/shiftDialog/${date.toISODate()}/persons/${encodeURIComponent(String(personRef))}/?${search}`));
};
export const shiftDialogShiftplansShiftPlanRefTaskrotationsTaskRotationRefGet = async (
    shiftPlanRef: number,
    taskRotationRef: number
): Promise<components["schemas"]["ShiftDialog.Result"]> => {
    return await client.fetch(HttpRequest.get(`/v1/shiftDialog/shiftplans/${encodeURIComponent(String(shiftPlanRef))}/taskrotations/${encodeURIComponent(String(taskRotationRef))}`));
};
export const shiftDialogDaytasktemplateDayTaskTemplateRefDelete = async (
    dayTaskTemplateRef: number
): Promise<void> => {
    return await client.fetch(HttpRequest.delete(`/v1/shiftDialog/daytasktemplate/${encodeURIComponent(String(dayTaskTemplateRef))}`));
};
export const shiftPlansGet = async (): Promise<void> => {
    return await client.fetch(HttpRequest.get("/v1/ShiftPlans"));
};
export const shiftPlansPost = async (
    requestBody: components["schemas"]["ShiftPlan.ShiftPlan"]
): Promise<void> => {
    return await client.fetch(HttpRequest.postJson("/v1/ShiftPlans", requestBody));
};
export const shiftPlansShiftPlanRefGet = async (
    shiftPlanRef: number
): Promise<void> => {
    return await client.fetch(HttpRequest.get(`/v1/ShiftPlans/${encodeURIComponent(String(shiftPlanRef))}`));
};
export const shiftPlansShiftPlanRefPut = async (
    shiftPlanRef: number,
    requestBody: components["schemas"]["ShiftPlan.ShiftPlan"]
): Promise<void> => {
    return await client.fetch(HttpRequest.putJson(`/v1/ShiftPlans/${encodeURIComponent(String(shiftPlanRef))}`, requestBody));
};
export const shiftPlansShiftPlanRefDelete = async (
    shiftPlanRef: number
): Promise<void> => {
    return await client.fetch(HttpRequest.delete(`/v1/ShiftPlans/${encodeURIComponent(String(shiftPlanRef))}`));
};
export const shiftPlansShiftPlanRefPatch = async (
    shiftPlanRef: number,
    requestBody: ({
              /** @enum {string} */
              op: "Get" | "Put" | "Post" | "Delete" | "Options" | "Head" | "Patch" | "Trace";
              path: string;
              value: unknown;
            })[]
): Promise<void> => {
    return await client.fetch(HttpRequest.patch(`/v1/ShiftPlans/${encodeURIComponent(String(shiftPlanRef))}`, requestBody));
};
export const shiftPlansShiftPlanRefPublishPost = async (
    shiftPlanRef: number,
    createServerJobs?: boolean
): Promise<void> => {
    const search = new URLSearchParams();
    if (createServerJobs !== undefined) search.set("createServerJobs", String(createServerJobs));
    return await client.fetch(HttpRequest.post(`/v1/ShiftPlans/${encodeURIComponent(String(shiftPlanRef))}/publish/?${search}`));
};
export const shiftPlansShiftPlanRefTaskrotationsGet = async (
    shiftPlanRef: number,
    validate?: boolean
): Promise<void> => {
    const search = new URLSearchParams();
    if (validate !== undefined) search.set("validate", String(validate));
    return await client.fetch(HttpRequest.get(`/v1/ShiftPlans/${encodeURIComponent(String(shiftPlanRef))}/taskrotations/?${search}`));
};
export const shiftPlansShiftPlanRefTaskrotationsPost = async (
    shiftPlanRef: number,
    requestBody: components["schemas"]["ShiftPlan.TaskRotation"]
): Promise<void> => {
    return await client.fetch(HttpRequest.postJson(`/v1/ShiftPlans/${encodeURIComponent(String(shiftPlanRef))}/taskrotations`, requestBody));
};
export const shiftPlansShiftPlanRefTaskrotationsTaskRotationRefPut = async (
    shiftPlanRef: number,
    taskRotationRef: number,
    requestBody: components["schemas"]["ShiftPlan.TaskRotation"],
    position?: number
): Promise<void> => {
    const search = new URLSearchParams();
    if (position !== undefined) search.set("position", String(position));
    return await client.fetch(HttpRequest.putJson(`/v1/ShiftPlans/${encodeURIComponent(String(shiftPlanRef))}/taskrotations/${encodeURIComponent(String(taskRotationRef))}/?${search}`, requestBody));
};
export const shiftPlansShiftPlanRefTaskrotationsTaskRotationRefDelete = async (
    shiftPlanRef: number,
    taskRotationRef: number
): Promise<void> => {
    return await client.fetch(HttpRequest.delete(`/v1/ShiftPlans/${encodeURIComponent(String(shiftPlanRef))}/taskrotations/${encodeURIComponent(String(taskRotationRef))}`));
};
export const shiftPlansShiftPlanRefTaskrotationsImportGet = async (
    shiftPlanRef: number
): Promise<void> => {
    return await client.fetch(HttpRequest.get(`/v1/ShiftPlans/${encodeURIComponent(String(shiftPlanRef))}/taskrotations/import`));
};
export const shiftPlansShiftPlanRefTaskrotationsImportPost = async (
    shiftPlanRef: number,
    requestBody: number
): Promise<void> => {
    return await client.fetch(HttpRequest.postJson(`/v1/ShiftPlans/${encodeURIComponent(String(shiftPlanRef))}/taskrotations/import`, requestBody));
};
export const shiftPlansShiftPlanRefTaskrotationsTaskRotationRefShiftsPost = async (
    shiftPlanRef: number,
    taskRotationRef: number,
    requestBody: components["schemas"]["ShiftPlan.Shift"]
): Promise<void> => {
    return await client.fetch(HttpRequest.postJson(`/v1/ShiftPlans/${encodeURIComponent(String(shiftPlanRef))}/taskrotations/${encodeURIComponent(String(taskRotationRef))}/shifts`, requestBody));
};
export const shiftPlansShiftPlanRefTaskrotationsTaskRotationRefShiftsShiftPositionDelete = async (
    shiftPlanRef: number,
    taskRotationRef: number,
    shiftPosition: number
): Promise<void> => {
    return await client.fetch(HttpRequest.delete(`/v1/ShiftPlans/${encodeURIComponent(String(shiftPlanRef))}/taskrotations/${encodeURIComponent(String(taskRotationRef))}/shifts/${encodeURIComponent(String(shiftPosition))}`));
};
export const shiftPlansShiftPlanRefTaskrotationsTaskRotationRefStaffslotsPost = async (
    shiftPlanRef: number,
    taskRotationRef: number,
    requestBody: components["schemas"]["StaffSlot"]
): Promise<void> => {
    return await client.fetch(HttpRequest.postJson(`/v1/ShiftPlans/${encodeURIComponent(String(shiftPlanRef))}/taskrotations/${encodeURIComponent(String(taskRotationRef))}/staffslots`, requestBody));
};
export const shiftPlansShiftPlanRefTaskrotationsTaskRotationRefStaffslotsStaffSlotRefPut = async (
    shiftPlanRef: number,
    taskRotationRef: number,
    staffSlotRef: number,
    requestBody: components["schemas"]["StaffSlot"]
): Promise<void> => {
    return await client.fetch(HttpRequest.putJson(`/v1/ShiftPlans/${encodeURIComponent(String(shiftPlanRef))}/taskrotations/${encodeURIComponent(String(taskRotationRef))}/staffslots/${encodeURIComponent(String(staffSlotRef))}`, requestBody));
};
export const shiftPlansShiftPlanRefTaskrotationsTaskRotationRefStaffslotsStaffSlotRefDelete = async (
    shiftPlanRef: number,
    taskRotationRef: number,
    staffSlotRef: number
): Promise<void> => {
    return await client.fetch(HttpRequest.delete(`/v1/ShiftPlans/${encodeURIComponent(String(shiftPlanRef))}/taskrotations/${encodeURIComponent(String(taskRotationRef))}/staffslots/${encodeURIComponent(String(staffSlotRef))}`));
};
export const shiftPlansShiftPlanRefComputationsGet = async (
    shiftPlanRef: number,
    startDate?: DateTime,
    untilDate?: DateTime,
    workingTimeRegulationCheck?: boolean
): Promise<void> => {
    const search = new URLSearchParams();
    if (startDate !== undefined) search.set("startDate", String(startDate));
    if (untilDate !== undefined) search.set("untilDate", String(untilDate));
    if (workingTimeRegulationCheck !== undefined) search.set("workingTimeRegulationCheck", String(workingTimeRegulationCheck));
    return await client.fetch(HttpRequest.get(`/v1/ShiftPlans/${encodeURIComponent(String(shiftPlanRef))}/computations/?${search}`));
};
export const shiftPlansShiftPlanRefTaskrotationsTaskRotationRefAvailable_daytasksGet = async (
    shiftPlanRef: number,
    taskRotationRef: number
): Promise<void> => {
    return await client.fetch(HttpRequest.get(`/v1/ShiftPlans/${encodeURIComponent(String(shiftPlanRef))}/taskrotations/${encodeURIComponent(String(taskRotationRef))}/available_daytasks`));
};
export const shiftPlansShiftPlanRefTaskrotationsTaskRotationRefAvailable_personsGet = async (
    shiftPlanRef: number,
    taskRotationRef: number
): Promise<void> => {
    return await client.fetch(HttpRequest.get(`/v1/ShiftPlans/${encodeURIComponent(String(shiftPlanRef))}/taskrotations/${encodeURIComponent(String(taskRotationRef))}/available_persons`));
};
export const settingsShifttypesGet = async (): Promise<components["schemas"]["ShiftType"][]> => {
    return await client.fetch(HttpRequest.get("/v1/settings/shifttypes"));
};
export const settingsShifttypesPost = async (
    requestBody: components["schemas"]["ShiftTypesBody"]
): Promise<void> => {
    return await client.fetch(HttpRequest.postJson("/v1/settings/shifttypes", requestBody));
};
export const staffPersonRefDoneinserverqueueGet = async (
    personRef: number,
    date?: DateTime
): Promise<void> => {
    const search = new URLSearchParams();
    if (date !== undefined) search.set("date", String(date));
    return await client.fetch(HttpRequest.get(`/v1/staff/${encodeURIComponent(String(personRef))}/doneinserverqueue/?${search}`));
};
export const staffPersonRefManualdeviationsPost = async (
    personRef: number,
    requestBody: components["schemas"]["PersonAssignedTaskRotation.Result"][]
): Promise<components["schemas"]["PersonTaskRotationRolloutValidation.Result"]> => {
    return await client.fetch(HttpRequest.postJson(`/v1/staff/${encodeURIComponent(String(personRef))}/manualdeviations`, requestBody));
};
export const staffPersonRefSchedulesandperiodsGet = async (
    personRef: number
): Promise<components["schemas"]["PersonScheduleAndPeriodResult"]> => {
    return await client.fetch(HttpRequest.get(`/v1/staff/${encodeURIComponent(String(personRef))}/schedulesandperiods`));
};
export const staffPersonRefSchedulesandperiodsPost = async (
    personRef: number,
    requestBody: components["schemas"]["UpdateSchedulesAndPeriodsCommand"]
): Promise<components["schemas"]["PersonScheduleAndPeriodResult"]> => {
    return await client.fetch(HttpRequest.postJson(`/v1/staff/${encodeURIComponent(String(personRef))}/schedulesandperiods`, requestBody));
};
export const staffPersonRefCalendarGet = async (
    personRef: number,
    fromDate?: DateTime,
    untilDate?: DateTime
): Promise<components["schemas"]["PersonCalendar.Result"][]> => {
    const search = new URLSearchParams();
    if (fromDate !== undefined) search.set("fromDate", String(fromDate));
    if (untilDate !== undefined) search.set("untilDate", String(untilDate));
    return await client.fetch(HttpRequest.get(`/v1/staff/${encodeURIComponent(String(personRef))}/calendar/?${search}`));
};
export const staffPersonsGet = async (
    withoutActiveContract?: boolean
): Promise<components["schemas"]["Staff.Models.Person"][]> => {
    const search = new URLSearchParams();
    if (withoutActiveContract !== undefined) search.set("withoutActiveContract", String(withoutActiveContract));
    return await client.fetch(HttpRequest.get(`/v1/staff/persons/?${search}`));
};
export const staffPersonsPost = async (
    requestBody: components["schemas"]["CollectedOnboardingData"]
): Promise<components["schemas"]["Staff.Models.Person"][]> => {
    return await client.fetch(HttpRequest.postJson("/v1/staff/persons", requestBody));
};
export type staffPersonsPostError = { jsonError?: paths["/v1/staff/persons"]["post"]["responses"]["400"]["content"]["application/json"], message?: string, response: Response };
export const staffPersonscsvGet = async (): Promise<void> => {
    return await client.fetch(HttpRequest.get("/v1/staff/personscsv"));
};
export const staffPersonsfullGet = async (): Promise<components["schemas"]["PersonFull"][]> => {
    return await client.fetch(HttpRequest.get("/v1/staff/personsfull"));
};
export const staffOndutyGet = async (): Promise<components["schemas"]["Models.Container"][]> => {
    return await client.fetch(HttpRequest.get("/v1/staff/onduty"));
};
export const staffOndutyimagePersonRefGet = async (
    personRef: number
): Promise<void> => {
    return await client.fetch(HttpRequest.get(`/v1/staff/ondutyimage/${encodeURIComponent(String(personRef))}`));
};
export const storeSubscriptionGet = async (): Promise<components["schemas"]["Models.Subscription"]> => {
    return await client.fetch(HttpRequest.get("/v1/store/subscription"));
};
export const storeCheckoutPost = async (
    requestBody: components["schemas"]["UpdateSubscription.Command"]
): Promise<components["schemas"]["UpdateSubscription.Result"]> => {
    return await client.fetch(HttpRequest.postJson("/v1/store/checkout", requestBody));
};
export const storeCheckoutSuccessGet = async (
    sessionId?: string
): Promise<void> => {
    const search = new URLSearchParams();
    if (sessionId !== undefined) search.set("sessionId", sessionId);
    return await client.fetch(HttpRequest.get(`/v1/store/checkoutSuccess/?${search}`));
};
export const storePaymentInfoGet = async (): Promise<void> => {
    return await client.fetch(HttpRequest.get("/v1/store/paymentInfo"));
};
export const storePaymentInfoSuccessGet = async (
    sessionId?: string
): Promise<void> => {
    const search = new URLSearchParams();
    if (sessionId !== undefined) search.set("sessionId", sessionId);
    return await client.fetch(HttpRequest.get(`/v1/store/paymentInfoSuccess/?${search}`));
};
export const systemInformationGet = async (): Promise<components["schemas"]["SystemInformation"]> => {
    return await client.fetch(HttpRequest.get("/v1/SystemInformation"));
};
export const systemInformationOnlineGet = async (): Promise<boolean> => {
    return await client.fetch(HttpRequest.get("/v1/SystemInformation/online"));
};
export const systemInformationInitializePost = async (
    requestBody: components["schemas"]["InitializeSystem.Command"]
): Promise<void> => {
    return await client.fetch(HttpRequest.postJson("/v1/SystemInformation/initialize", requestBody));
};
export const taskrotationGettaskrotationlistGet = async (
    taskRotationRef?: number,
    useDivisions?: boolean,
    selectedDayTaskTemplateRef?: number,
    selectedCostDivisionOrDivisionRef?: number,
    hotelRef?: number
): Promise<components["schemas"]["TaskRotationList"]> => {
    const search = new URLSearchParams();
    if (taskRotationRef !== undefined) search.set("taskRotationRef", String(taskRotationRef));
    if (useDivisions !== undefined) search.set("useDivisions", String(useDivisions));
    if (selectedDayTaskTemplateRef !== undefined) search.set("selectedDayTaskTemplateRef", String(selectedDayTaskTemplateRef));
    if (selectedCostDivisionOrDivisionRef !== undefined) search.set("selectedCostDivisionOrDivisionRef", String(selectedCostDivisionOrDivisionRef));
    if (hotelRef !== undefined) search.set("hotelRef", String(hotelRef));
    return await client.fetch(HttpRequest.get(`/v1/taskrotation/gettaskrotationlist/?${search}`));
};
export const timeClockRefreshsessionGet = async (
    devices?: ("Legacy" | "DigitalPersona" | "SmartCardReader")[],
    newerThan?: DateTime
): Promise<components["schemas"]["RefreshSession.Response"]> => {
    const search = new URLSearchParams();
    for (const element of devices ?? []) {
        search.append("devices", String(element));
    }
    if (newerThan !== undefined) search.set("newerThan", String(newerThan));
    return await client.fetch(HttpRequest.get(`/v1/TimeClock/refreshsession/?${search}`));
};
export const timeClockEnrollmentallowedGet = async (
    personRef?: number
): Promise<boolean> => {
    const search = new URLSearchParams();
    if (personRef !== undefined) search.set("personRef", String(personRef));
    return await client.fetch(HttpRequest.get(`/v1/TimeClock/enrollmentallowed/?${search}`));
};
export const timeClockEnrollPost = async (
    requestBody: components["schemas"]["FingerIdentity"]
): Promise<void> => {
    return await client.fetch(HttpRequest.postJson("/v1/TimeClock/enroll", requestBody));
};
export const timeClockAuthenticatePost = async (
    requestBody: components["schemas"]["Authentication.Request"]
): Promise<components["schemas"]["AuthenticationResponse"]> => {
    return await client.fetch(HttpRequest.postJson("/v1/TimeClock/authenticate", requestBody));
};
export const timeClockStampPost = async (
    requestBody: components["schemas"]["StampCommand"]
): Promise<void> => {
    return await client.fetch(HttpRequest.postJson("/v1/TimeClock/stamp", requestBody));
};
export const timeClockOfflinestampsPost = async (
    requestBody: components["schemas"]["OfflineStampUploadRequest"]
): Promise<components["schemas"]["OfflineStampUploadResponse"]> => {
    return await client.fetch(HttpRequest.postJson("/v1/TimeClock/offlinestamps", requestBody));
};
export const timeClockSelfregisterPost = async (
    requestBody: components["schemas"]["SelfRegistrationRequest"]
): Promise<components["schemas"]["SelfRegistrationResponse"]> => {
    return await client.fetch(HttpRequest.postJson("/v1/TimeClock/selfregister", requestBody));
};
export const timeClockSelfregisterCostdivisionsGet = async (): Promise<components["schemas"]["StampCostDivision"][]> => {
    return await client.fetch(HttpRequest.get("/v1/TimeClock/selfregister/costdivisions"));
};
export const timeClockBalancePersonRefGet = async (
    personRef: number
): Promise<components["schemas"]["TerminalBalance"][]> => {
    return await client.fetch(HttpRequest.get(`/v1/TimeClock/balance/${encodeURIComponent(String(personRef))}`));
};
export const timeClockPingPost = async (
    requestBody: {
            [key: string]: string;
          }
): Promise<void> => {
    return await client.fetch(HttpRequest.postJson("/v1/TimeClock/ping", requestBody));
};
export const timeReportSalaryPeriodSalaryPeriodRefGet = async (
    salaryPeriodRef: number
): Promise<components["schemas"]["GetTimeReportData.Result"]> => {
    return await client.fetch(HttpRequest.get(`/v1/TimeReport/salaryPeriod/${encodeURIComponent(String(salaryPeriodRef))}`));
};
export const timeReportSalaryPeriodSalaryPeriodRefLockPost = async (
    salaryPeriodRef: number
): Promise<components["schemas"]["LockTimeReport.Result"]> => {
    return await client.fetch(HttpRequest.post(`/v1/TimeReport/salaryPeriod/${encodeURIComponent(String(salaryPeriodRef))}/lock`));
};
export const timeReportSalaryPeriodSalaryPeriodRefPersonRefRevokePost = async (
    salaryPeriodRef: number,
    personRef: number
): Promise<void> => {
    return await client.fetch(HttpRequest.post(`/v1/TimeReport/salaryPeriod/${encodeURIComponent(String(salaryPeriodRef))}/${encodeURIComponent(String(personRef))}/revoke`));
};
export const timeReportPost = async (
    requestBody: components["schemas"]["UpdateDayModel"]
): Promise<void> => {
    const content = {
        ...requestBody,
        date: requestBody.date.toISODate(),
    };
    return await client.fetch(HttpRequest.postJson("/v1/TimeReport", content));
};
